/** Loading placeholders aligned with Tailwind `.skeleton` (gray pulse), not MUI blue. */

export function GoalsListSkeleton() {
  return (
    <div className="grid gap-4">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="bg-white rounded-xl shadow p-4 flex items-center justify-between flex-wrap gap-4"
        >
          <div className="flex-1 min-w-0 space-y-2">
            <div className="h-5 skeleton rounded w-48 max-w-full" />
            <div className="h-4 skeleton rounded w-full max-w-md" />
            <div className="h-4 skeleton rounded w-24" />
          </div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 skeleton rounded-lg" />
            <div className="w-9 h-9 skeleton rounded-lg" />
            <div className="w-9 h-9 skeleton rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ActivityTableSkeleton() {
  return (
    <div className="bg-white rounded-xl shadow overflow-hidden">
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="flex gap-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-3 skeleton rounded flex-1 max-w-[120px]" />
          ))}
        </div>
      </div>
      <div className="divide-y divide-gray-100">
        {[1, 2, 3, 4, 5, 6].map((row) => (
          <div key={row} className="px-4 py-3 flex gap-3 items-center">
            <div className="h-4 skeleton rounded w-36 shrink-0" />
            <div className="h-4 skeleton rounded w-28 shrink-0" />
            <div className="h-4 skeleton rounded w-32 shrink-0" />
            <div className="h-4 skeleton rounded flex-1 min-w-0" />
            <div className="h-4 skeleton rounded w-24 shrink-0 hidden sm:block" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function GoalDetailSkeleton() {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="h-4 skeleton rounded w-32" />
      <div className="bg-white rounded-xl shadow p-6 space-y-3">
        <div className="h-8 skeleton rounded w-2/3 max-w-md" />
        <div className="h-4 skeleton rounded w-full" />
        <div className="h-4 skeleton rounded w-full" />
        <div className="h-4 skeleton rounded w-40" />
      </div>
      <div className="bg-white rounded-xl shadow p-6 space-y-3">
        <div className="h-6 skeleton rounded w-32" />
        <div className="h-10 skeleton rounded w-full" />
      </div>
    </div>
  );
}
